import React, { Component } from "react";
import { observer } from "mobx-react";
import {getCurrentUtc} from "../../utils/commonUtils";
import {formatCountTime} from "../../utils/contractUtils";

import "./upcomingTimer.less";
import {Button} from "antd";

interface IProps {
    countTime:number
}

interface IStates {
}

let interval: NodeJS.Timeout;

@observer
class FreeMintPageUpcomingTimer extends Component<IProps, IStates> {
    countDownTime = () => {
        interval = setInterval(() => {
            this.setState({});
        }, 1000)
    };

    renderTime = () => {
        if(!this.props.countTime){
            return <>0D 0H 0M 0S</>
        }
        let timeRemaining = this.props.countTime - getCurrentUtc() / 1000;
        if ( timeRemaining <= 0) {
            timeRemaining = 0;
            clearInterval(interval);
        }
        const countTime = formatCountTime(timeRemaining);
        return <><span>{countTime.Days}</span>D <span>{countTime.Hours}</span>H <span>{countTime.Minutes}</span>M <span>{countTime.Secs}S</span></>
    };
    componentWillUnmount() {
        clearInterval(interval);
    }

    componentDidMount() {
        this.countDownTime();
    }

    render() {
        return<Button style={{width:"5.5rem"}} className="myth-button" disabled={true}>
            {this.renderTime()}
        </Button>
    }
}

export default FreeMintPageUpcomingTimer;